import { render, staticRenderFns } from "./DialogAnnounceCheckUserOnechat.vue?vue&type=template&id=795ca480&scoped=true&"
import script from "./DialogAnnounceCheckUserOnechat.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceCheckUserOnechat.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceCheckUserOnechat.vue?vue&type=style&index=0&id=795ca480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ca480",
  null
  
)

export default component.exports